import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form/immutable';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { Calendar } from 'react-widgets';

import misc from '../../misc';
import 'react-widgets/dist/css/react-widgets.css';

export class SessionEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { calendarOpen: false };
  }

  onDateFocus() {
    this.setState({ calendarOpen: true });
  }

  handleDateChange(value) {
    this.props.change('date', value);
    this.setState({ calendarOpen: false });
  }

  renderForm() {
    const {
      handleSubmit,
      error,
      pristine,
      submitting,
      isLoading,
      initialValues
    } = this.props;

    return (
      <div className="row justify-content-md-center">
        <form
          className="container"
          onSubmit={handleSubmit(this.props.onSubmit)}
        >
          Session Details
          {error && <misc.components.Alert message={error} />}
          <div className="form-group">
            <Field
              name="clientIds"
              component={misc.components.Widgets.renderMultiselect}
              data={this.props.allClients}
              textField={item => `${item.firstName} ${item.lastName}`}
              valueField="id"
              placeholder="Add one or more clients..."
              messages={{
                emptyList: 'No clients to select',
                emptyFilter: 'No matching clients'
              }}
            />
          </div>
          {this.renderDateTimeInputs()}
          <div className="row justify-content-md-center text-center">
            <div className="col text-center form-group">
              <div className="form-check form-check-inline mr-3">
                <label className="form-check-label">
                  <Field
                    name="duration"
                    component="input"
                    type="radio"
                    value="30"
                  />{' '}
                  Half hour
                </label>
              </div>
              <div className="form-check form-check-inline ml-3">
                <label className="form-check-label">
                  <Field
                    name="duration"
                    component="input"
                    type="radio"
                    value="60"
                  />{' '}
                  Full hour
                </label>
              </div>
            </div>
          </div>
          <div className="form-group">
            <Field
              name="locationId"
              component={misc.components.Widgets.renderDropdownList}
              data={this.props.allLocations}
              textField="name"
              valueField="id"
              placeholder="Location..."
              required
            />
          </div>
          <div className="row justify-content-md-center text-center">
            <div className="col text-center form-group">
              <div className="form-check form-check-inline mr-3">
                <label className="form-check-label">
                  <Field
                    name="recurs"
                    component="input"
                    type="checkbox"
                    value={false}
                  />{' '}
                  Repeat weekly
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Link
                to={
                  initialValues.get('clientIds').size < 1
                    ? '/clients'
                    : `/clients/${initialValues.get('clientIds').first()}`
                }
                className="btn btn-lg btn-secondary btn-block"
              >
                Cancel
              </Link>
            </div>
            <div className="col">
              <misc.components.LoadingButton
                disabled={pristine || submitting}
                loading={isLoading}
                className="btn-lg"
              >
                {typeof initialValues.get('id') === 'undefined'
                  ? 'Book'
                  : 'Update'}
              </misc.components.LoadingButton>
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderDateTimeInputs() {
    Moment.locale('en');
    momentLocalizer();
    if (this.state.calendarOpen) {
      return (
        <div className="row justify-content-md-center">
          <div className="col text-center form-group">
            <Calendar
              defaultValue={this.props.dateValue}
              onChange={value => this.handleDateChange(value)}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="row justify-content-md-center">
          <div className="col col-md-6">
            <div className="form-group">
              <Field
                component={misc.components.FormField}
                name="date"
                id="date"
                type="input"
                onFocus={this.onDateFocus.bind(this)}
                format={value => Moment(value).format('MMM D, YYYY')}
                required
              />
            </div>
          </div>
          <div className="col col-md-6">
            <Field
              component={misc.components.FormField}
              name="time"
              type="select"
              required
            >
              <option value="06:00">6:00 am</option>
              <option value="06:30">6:30 am</option>
              <option value="07:00">7:00 am</option>
              <option value="07:30">7:30 am</option>
              <option value="08:00">8:00 am</option>
              <option value="08:30">8:30 am</option>
              <option value="09:00">9:00 am</option>
              <option value="09:30">9:30 am</option>
              <option value="10:00">10:00 am</option>
              <option value="10:30">10:30 am</option>
              <option value="11:00">11:00 am</option>
              <option value="11:30">11:30 am</option>
              <option value="12:00">12:00 pm</option>
              <option value="12:30">12:30 pm</option>
              <option value="13:00">1:00 pm</option>
              <option value="13:30">1:30 pm</option>
              <option value="14:00">2:00 pm</option>
              <option value="14:30">2:30 pm</option>
              <option value="15:00">3:00 pm</option>
              <option value="15:30">3:30 pm</option>
              <option value="16:00">4:00 pm</option>
              <option value="16:30">4:30 pm</option>
              <option value="17:00">5:00 pm</option>
              <option value="17:30">5:30 pm</option>
              <option value="18:00">6:00 pm</option>
              <option value="18:30">6:30 pm</option>
              <option value="19:00">7:00 pm</option>
              <option value="19:30">7:30 pm</option>
              <option value="20:00">8:00 pm</option>
              <option value="20:30">8:30 pm</option>
            </Field>
          </div>
        </div>
      );
    }
  }

  render() {
    const { isLoading, isError, errorMessage, submitting } = this.props;
    return (
      <div className="col-md-9 content">
        {!submitting && isLoading && <misc.components.LoadingAlert />}
        {isError && <misc.components.Alert message={errorMessage} />}
        {this.renderForm()}
      </div>
    );
  }
}

SessionEdit.propTypes = {
  initialValues: PropTypes.shape({
    id: PropTypes.string,
    clientIds: PropTypes.array,
    date: PropTypes.date,
    duration: PropTypes.string, // redux-form Field radio values are strings – conversion happens in container
    locationId: PropTypes.string,
    recurs: PropTypes.boolean
  }),
  errorMessage: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

SessionEdit.defaultProps = {
  isLoading: false,
  isError: false,
  errorMessage: 'Sorry, an error occurred.'
};

export const validate = values => {
  const errors = {};

  if (values.get('clientIds').size < 1) {
    errors.clientIds = 'One or more clients are required';
  }

  if (!values.get('date')) {
    errors.date = 'Date is required';
  }

  if (!values.get('time')) {
    errors.time = 'Time is required';
  }

  if (!values.get('duration')) {
    errors.duration = 'Duration is required';
  }

  if (!values.get('locationId')) {
    errors.locationId = 'Location is required';
  }

  return errors;
};

// Can we move this and connect() call out of form? Only needed for Calendar
const selector = formValueSelector('sessionForm');
const mapStateToProps = state => {
  const dateValue = selector(state, 'date');
  return {
    dateValue
  };
};

export default reduxForm({
  validate,
  form: 'sessionForm'
})(connect(mapStateToProps)(SessionEdit));



// WEBPACK FOOTER //
// ./src/modules/sessions/components/SessionEdit.js